<template>
  <v-bottom-sheet v-model="show" persistent>
    <v-sheet class="text-center" height="300px">
      <div class="py-10">Souhaitez-vous tenter de récupérer votre ancien panier ?</div>
      <v-row>
        <v-col>
          <v-btn
            text
            color="error"
            @click="closeDialog()"
          >annuler</v-btn>
        </v-col>
        <v-col>
          <v-btn
            text
            color="success"
            @click="recoverFromOldCart()"
          >confirmer</v-btn>
        </v-col>
      </v-row>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
  import { RECOVER_OLD_CART } from '@/store/actions/cart'
  import { CLOSE_RECOVER_CART_DIALOG  } from '@/store/actions/general'

  export default {
    name: 'OldCartDialog',
    
    props: {
      show: Boolean,
    },

    methods: {
      closeDialog() {
        this.$emit(CLOSE_RECOVER_CART_DIALOG)
      },
      recoverFromOldCart() {
        this.$store.dispatch(RECOVER_OLD_CART)
        this.closeDialog()
      }
    }
  }
</script>